import React from 'react';
import { EducationalLayout } from '../../contentful/templates/EducationalLayout';
import { NavigationalLayout } from '../../contentful/templates/NavigationalLayout';
import { InspirationalLayout } from '../../contentful/templates/InspirationalLayout';

export const getLayoutTemplate = (layouts) => {
  const pageTemplate = layouts?.content?.__typename;

  switch (pageTemplate) {
  case 'EducationalLayout':
    return EducationalLayout;
  case 'NavigationalLayout':
    return NavigationalLayout;
  case 'InspirationalLayout':
    return InspirationalLayout;
  default:
    return () => React.Fragment;
  }
};